import * as React from "react"

const ArrowUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M7.5 12v.5h1V6l2.1 2 .4.4.7-.7-.3-.3-3-3L8 4l-.4.4-.1.1-2.9 2.9-.3.3.7.7.4-.3 2.1-2.2V12Z" />
  </svg>
)

export default ArrowUp
